import { AiOutlinePartition } from 'react-icons/ai';
import { AiOutlineFundView } from 'react-icons/ai';
import { BsFillPeopleFill } from 'react-icons/bs';
import { VscServerProcess } from 'react-icons/vsc';
import { FcInspection } from 'react-icons/fc';
import { MdApproval, MdDriveFolderUpload } from 'react-icons/md';
import { TbReport } from 'react-icons/tb';
import { HiDocumentReport } from 'react-icons/hi';
import { SiInformatica } from 'react-icons/si';
import { FaProcedures } from 'react-icons/fa';
import { MdOutlineIntegrationInstructions } from 'react-icons/md';
const tiles = [
  {
    sNo: 1,
    link: '/common/company_roles_responsibilities_listOfProcedures?documentType=clause4ListOfProcedure',
    isLink: true,
    icon: <MdDriveFolderUpload size="5rem" color="#003566" />,
    p: 'LIST OF',
    span: 'PROCEDURE',
    isIcon: true,
  },
  {
    sNo: 1,
    link: '/admin/part_list?filter=part_number',
    isLink: true,
    clauseNo: 4,
    icon: <AiOutlinePartition size="5rem" color="#a12222" />,
    p: 'ADD',
    span: 'PART',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/admin/ppap_documents?filter=part_number',
    isLink: true,
    clauseNo: 4,
    p: 'VIEW',
    span: 'PPAP DOCUMENTS',
    icon: <AiOutlineFundView size="5rem" color="#343a40" />,
    isIcon: true,
  },
  {
    sNo: 3,
    link: '/admin/customer_list?filter=createdAt',
    isLink: true,
    clauseNo: 4,
    p: 'MASTER LIST OF',
    span: 'CUSTOMER',
    icon: <BsFillPeopleFill size="5rem" color="#135089" />,
    isIcon: true,
  },
  {
    sNo: 1,
    link: '/common/pirList',
    isLink: true,
    icon: <VscServerProcess size="5rem" color="#135089" />,
    p: 'PIR',
    span: 'REPORT',
    isIcon: true,
  },
  // {
  //   sNo: 1,
  //   link: '/admin/lineInspectionList',
  //   isLink: true,
  //   icon: <VscServerProcess size="5rem" color="#a12222" />,
  //   p: 'LINE',
  //   span: 'INSPECTION',
  //   isIcon: true,
  // },
  {
    sNo: 1,
    link: '/admin/pdirList',
    isLink: true,
    icon: <TbReport size="5rem" color="#a12222" />,
    p: 'PDIR',
    span: 'REPORT',
    isIcon: true,
  },
  // {
  //   sNo: 1,
  //   link: '/admin/setupList',
  //   isLink: true,
  //   icon: <MdApproval size="5rem" color="#a12222" />,
  //   p: 'FPA/',
  //   span: 'LPA',
  //   isIcon: true,
  // },
  // // {
  // //   sNo: 1,
  // //   link: '/admin/incomingReportList',
  // //   isLink: true,
  // //   icon: <FcInspection size="5rem" color="#a12222" />,
  // //   p: 'INCOMING INSPECTION',
  // //   span: 'STANDARD',
  // //   isIcon: true,
  // // },
  // {
  //   sNo: 1,
  //   link: '/admin/materialIncomingList',
  //   isLink: true,
  //   icon: <FcInspection size="5rem" color="#a12222" />,
  //   p: 'INCOMING MATERIAL',
  //   span: 'INSPECTION',
  //   isIcon: true,
  // },
  {
    sNo: 19,
    link: `/common/masterFormatsUpload/?documentType=masterFormatsUpload&heading=MASTER FORMATS UPLOAD`,
    isLink: true,
    icon: <HiDocumentReport size="5rem" color="#003566" />,
    p: 'Master',
    span: 'Formats',
    isIcon: true,
  },
  {
    sNo: 19,
    link: `/common/masterProcedureNewUpload/?documentType=masterProcedureNewUpload&heading=MASTER PROCEDURE`,
    isLink: true,
    icon: <HiDocumentReport size="5rem" color="orange" />,
    p: 'Master',
    span: 'Procedure',
    isIcon: true,
  },
  {
    sNo: 19,
    link: `/common/workInstructionsUpload/?documentType=workInstructionsUpload&heading=WORK INSTRUCTIONS`,
    isLink: true,
    icon: <HiDocumentReport size="5rem" color="green" />,
    p: 'WORK',
    span: 'INSTRUCTIONS',
    isIcon: true,
  },
];

export default tiles;
